module.exports = __webpack_public_path__ + "img/144.c18fde58.jpg";